import {WordService} from './word.service';
import {WordHistoryService} from './word-history.service';
import {WordBookmarkService} from './word-bookmark.service';

export const WordInjectables: Array<any> = [
  {
    provide: WordService,
    useClass: WordService,
  },
  {
    provide: WordHistoryService,
    useClass: WordHistoryService,
  },
  {
    provide: WordBookmarkService,
    useClass: WordBookmarkService,
  },
];
